var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image flex flex-center"},[_c('span',{staticClass:"letter"},[_vm._v(" "+_vm._s(_vm.label[0])+" ")]),_c('a',{staticClass:"icon",attrs:{"href":"#"}},[_c('b-flix-icon',{attrs:{"icon":"camera"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }